import { useTranslation } from 'react-i18next';
import { RichTextEditor } from '@/shared/components/custom/rich-text-editor';
import { htmlToEditorJson } from '../adapters/content-html.adapter';
import { NoteVersionBanner } from './NoteVersionBanner';
import type { NoteVersion } from '../types';

interface NoteVersionViewProps {
  version: NoteVersion;
  onClose: () => void;
  onRestore: () => void;
  isRestoring: boolean;
}

/** Read-only rendering of a historical version, replacing the normal edit view while active. */
export function NoteVersionView({
  version,
  onClose,
  onRestore,
  isRestoring,
}: NoteVersionViewProps) {
  const { t } = useTranslation('notes');

  return (
    <div className="flex h-full flex-col">
      <NoteVersionBanner
        createdAt={version.createdAt}
        onClose={onClose}
        onRestore={onRestore}
        isRestoring={isRestoring}
      />
      <div className="flex-1 overflow-y-auto px-6 py-4 md:px-10">
        <div className="max-w-3xl">
          <h1 className="mb-2 text-xl font-bold text-foreground md:text-2xl">
            {version.title || t('editor.titlePlaceholder')}
          </h1>
          <RichTextEditor value={htmlToEditorJson(version.content ?? '')} readOnly />
        </div>
      </div>
    </div>
  );
}
